import { operatorApiFetch } from './apiService';

export const salesChannelService = {
  // 列表
  list: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.since_id) queryParams.append('since_id', params.since_id);
    if (params.page_size) queryParams.append('page_size', params.page_size);
    if (params.search) queryParams.append('search', params.search);
    if (params.merchant_id) queryParams.append('merchant_id', params.merchant_id);

    const response = await operatorApiFetch(`sales_channels?${queryParams.toString()}`, { method: 'GET' });
    return response.json();
  },

  // 列表（用於表格）
  getRecords: async (params) => {
    const response = await operatorApiFetch('sales_channels/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await operatorApiFetch('sales_channels/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 獲取單個
  get: async (id) => {
    const response = await operatorApiFetch(`sales_channels/${id}`, { method: 'GET' });
    return response.json();
  },

  // 創建
  // payload 為 buildPayload 組出的完整 body（含 sales_channel 與 top-level
  // sales_channel_rules / sales_channel_shipping_rules），不可只送 sales_channel，
  // 否則後端讀不到 top-level 規則參數、規則不會被儲存。
  create: async (payload, merchantId) => {
    const response = await operatorApiFetch('sales_channels', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...payload, merchant_id: merchantId }),
    });
    return response.json();
  },

  // 更新
  // payload 同上：送完整 body，保留 top-level 規則參數。
  update: async (id, payload) => {
    const response = await operatorApiFetch(`sales_channels/${id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    return response.json();
  }
};
export default salesChannelService;
